import i18n from '@/i18n';

export const languages = [
  {
    value: 'English',
    label: i18n.t('english', { ns: 'common' })
  },
  {
    value: 'Dutch',
    label: i18n.t('dutch', { ns: 'common' })
  },
  {
    value: 'French',
    label: i18n.t('french', { ns: 'common' })
  },
  {
    value: 'German',
    label: i18n.t('german', { ns: 'common' })
  }
];
